import { render } from "./KycPage.vue?vue&type=template&id=5b52a574&scoped=true"
import script from "./KycPage.vue?vue&type=script&lang=js"
export * from "./KycPage.vue?vue&type=script&lang=js"

import "./KycPage.vue?vue&type=style&index=0&id=5b52a574&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52a574"]])

export default __exports__